<template>
  <div>
    <div v-if="programInfo" class="ef-btn-banner-section px-0">
      <img
        :src="programInfo.programThumbnail || defaultThumbnail"
        alt
        class="banner-img"
      />
      <!-- back button -->
      <router-link
        :to="
          programInfo &&
          !(
            programInfo.programState == 'completed' ||
            programInfo.programState == 'expired'
          )
            ? '/user/programs'
            : '/user/programs/completed'
        "
        class="cursor-pointer font-weight-700 font-18 text-decoration-none position-absolute text-white w-100 back-button"
      >
        <b-icon-arrow-left class="mr-1 font-weight-700" />Back
      </router-link>
      <!-- top desktop thumbnail -->
      <div class="banner-content position-absolute d-none d-lg-block">
        <b-row class="w-100">
          <b-col class="p-3 gray-background" cols="5">
            <p class="bannerTitle1 font-weight-bold font-21">
              {{ programInfo.programName }}
            </p>
            <p
              class="font-weight-500 font-16 line-height-24"
              v-html="programInfo.description"
            ></p>
            <div class="mb-4">
              <label
                v-if="programInfo.programState === 'expired'"
                class="font-16 line-height-18 font-weight-500"
              >
                If you wish to continue working out, try out another
                <router-link
                  :to="{ name: 'b2b-programs' }"
                  class="color-primary"
                  >{{ name }}</router-link
                >
              </label>
              <label
                v-else-if="
                  programInfo.completedWorkouts >= programInfo.totalWorkouts
                "
                class="font-16 line-height-18 font-weight-500"
              >
                You have completed your {{ name }} for the day. If you wish to
                continue working out, proceed to the
                <router-link :to="{ name: 'Discover' }" class="color-primary"
                  >Discover page</router-link
                >
              </label>
              <label v-else-if="programInfo.programState === 'upcoming'">
                Program has not started yet, If you wish to continue working
                out, try out another
                <router-link
                  :to="{ name: 'b2b-programs' }"
                  class="color-primary"
                  >{{ name }}</router-link
                >
              </label>
              <label
                v-else-if="!programInfo.isRequiredProgramCompleted"
                class="font-16 line-height-18 font-weight-500"
              >
                Please complete
                <span  class="badge badge-dark font-14" role="button" @click="RedirectingToProgram(programInfo.requiredProgram)">{{
                  programInfo.requiredProgram.programName
                }}</span>
                before starting this program
              </label>
              <b-button
                v-else
                class="workout-button font-weight-bold d-flex flex-row justify-content-center align-items-center"
                @click="continueProgram"
              >
                <i class="icon-play3 mr-2"></i>
                {{ startButtonLabel }}
              </b-button>
            </div>
            <div class="challenge-progress">
              <label class="font-16 line-height-18 font-weight-500"
                >{{ programInfo.completedWorkouts }}/{{
                  programInfo.totalWorkouts
                }}
                Workouts</label
              >
              <b-progress
                :max="programInfo.totalWorkouts"
                :value="programInfo.completedWorkouts"
                class="w-100"
                height="5px"
                variant="success"
              >
              </b-progress>
            </div>
          </b-col>
          <b-col
            class="d-flex justify-content-around align-items-center"
            cols="4"
            offset="3"
          >
            <div class="p-4 countdown-container float-center text-wrap">
              <div class="d-flex justify-center-between">
                <img src="../assets/icons/clock.svg" /><span
                  class="ml-2 font-16 line-height-21 font-weight-500 text-white"
                  >{{ getLabel }}</span
                >
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- top mobile thumbnail -->
    <div
      v-if="programInfo"
      class="d-block d-lg-none workout-wrapper px-3 px-lg-5 py-3 py-lg-5"
    >
      <b-row>
        <b-col lg="5" md="12">
          <div class="challenge-progress-mobile">
            <label
              v-b-tooltip.hover
              :title="programInfo.programName"
              class="font-16 line-height-24 ef-dark title-line-limit ef-cursor-pointer text-uppercase"
              ><b>{{ programInfo.programName }}</b></label
            >
            <p
              class="font-weight-500 font-16 line-height-18"
              v-html="programInfo.description"
            ></p>
            <p class="font-16 line-height-18" v-if="programInfo.requiredProgram.programId">
              Please complete
                <span  class="badge badge-dark font-14" role="button" @click="RedirectingToProgram(programInfo.requiredProgram)">{{
                  programInfo.requiredProgram.programName
                }}</span>
                before starting this program
            </p>
            <div class="workout-progress-wrapper d-flex align-items-center">
              <img height="15" src="../assets/icons/clock.svg" width="15" />
              <span
                class="text-gray font-12 line-height-18 font-weight-500 ml-2"
                >{{ getLabel }}</span
              >
            </div>
            <label class="text-gray font-12 line-height-18 font-weight-500 mt-2"
              >{{ programInfo.completedWorkouts }}/{{
                programInfo.totalWorkouts
              }}
              Workouts</label
            >
            <b-progress
              :max="programInfo.totalWorkouts"
              :value="programInfo.completedWorkouts"
              class="w-100"
              height="5px"
              variant="success"
            >
            </b-progress>
          </div>
          <div
            class="d-md-block d-lg-none"
            style="padding: 16px; padding-right: 24px;"
          >
            <label
              v-if="programInfo.programState === 'expired'"
              class="font-16 line-height-18 font-weight-500"
            >
              If you wish to continue working out, try out another
              <router-link
                :to="{ name: 'b2b-challenges' }"
                class="color-primary"
                >{{ name }}</router-link
              >
            </label>
            <label
              v-else-if="
                programInfo.completedWorkouts >= programInfo.totalWorkouts
              "
              class="font-16 line-height-18 font-weight-500"
            >
              You have completed your challenge for the day. If you wish to
              continue working out, proceed to the
              <router-link :to="{ name: 'Discover' }" class="color-primary"
                >Discover page</router-link
              >
            </label>
            <b-button
              v-else
              class="mt-5 workout-button font-weight-bold d-flex flex-row justify-content-center align-items-center w-100"
              @click="continueProgram"
            >
              <i class="icon-play3 mr-2"></i>
              {{ startButtonLabel }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- videos -->
    <div class="w-100 mt-5">
      <div class="challenge-container mb-5 pb-5 px-3 px-lg-5">
        <b-container class="px-0 px-lg-5" fluid>
          <div
            v-for="(video, index) in videos"
            :key="index"
            :class="[
              !video.is_workout_completed
                ? 'challenge-wrapper'
                : 'challenge-wrapper-grey',
            ]"
            class="d-flex px-1"
          >
            <b-row class="w-100 m-0">
              <b-col lg="4" md="12">
                <div
                  class="video-thumbnail ef-cursor-pointer"
                  @click="goToVideo(video)"
                >
                  <img :src="video.thumbnail" width="100%" />
                  <div v-if="video.duration" class="video-duration">
                    {{ video.duration | videoDuration }}
                  </div>
                </div>
              </b-col>
              <b-col lg="8" md="12">
                <div class="workout-details">
                  <b-row>
                    <b-col>
                      <b-row
                        @click="goToVideo(video)"
                        class="ef-cursor-pointer"
                      >
                        <b-col>
                          <label
                            class="font-size-18 line-height-27 ef-cursor-pointer"
                            :class="{'notranslate' : !video.needTranslation}"
                            ><b>{{ video.title }}</b></label
                          >
                          <p
                            class="text-gray font-16 font-weight-500 line-height-24"
                          >
                            by
                            <span class="color-primary font-weight-bold">{{
                              video.tenantName
                            }}</span>
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <p
                            class="text-gray font-size-16 line-height-24 font-weight-500 py-2"
                          >
                            {{ video.description }}
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label
                        class="d-none d-md-block font-size-12 line-height-18 mr-2"
                        >{{ getWorkoutIntensity(video) }}</label
                      >
                      <label
                        v-for="(category, idx) in video.categories"
                        :key="idx"
                        class="font-12 line-height-18 color-primary border-green px-3 font-weight-500 rounded ml-1 ef-cursor-pointer"
                        @click="
                          getSimilarCategoriesVideos(category.category_id)
                        "
                        >{{ category.category_name }}</label
                      >
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-container>
        <b-row>
          <loader v-if="isLoading"></loader>
        </b-row>
        <div
          class="mt-5 d-flex justify-content-center align-items-center"
          v-if="programInfo && programInfo.programState == 'active' && type == 'individual' && videos.length !== 0"
        >
          <label
            class="text-red font-16 font-weight-bold line-height-24  ef-cursor-pointer"
            @click="askDeleteConfirmation"
          >
            <span class="mr-2">
              <svg
                fill="none"
                height="16"
                viewBox="0 0 16 16"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.7799 0.640039C10.7799 0.480909 10.7167 0.328297 10.6042 0.215775C10.4916 0.103253 10.339 0.0400391 10.1799 0.0400391H5.8199C5.66077 0.0400391 5.50816 0.103253 5.39564 0.215775C5.28312 0.328297 5.2199 0.480909 5.2199 0.640039V2.20004H0.899902V3.40004H1.9599V13.2C1.9599 13.932 2.25069 14.6341 2.76829 15.1517C3.28589 15.6693 3.98791 15.96 4.7199 15.96H11.3199C11.6814 15.9601 12.0394 15.8885 12.3731 15.7496C12.7068 15.6106 13.0098 15.407 13.2645 15.1505C13.5192 14.8939 13.7206 14.5895 13.8571 14.2547C13.9936 13.92 14.0625 13.5615 14.0599 13.2V3.40004H15.0999V2.20004H10.7799V0.640039ZM5.8599 12.26H4.6599V5.46004H5.8599V12.26ZM8.5999 12.26H7.3999V5.46004H8.5999V12.26ZM9.5799 2.20004H6.4199V1.24004H9.5799V2.20004ZM11.3399 5.46004V12.26H10.1399V5.46004H11.3399Z"
                  fill="#BC4444"
                />
              </svg>
            </span>
            <span>Leave Challenge</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImageBanner from "@/components/ImageBanner";
import { createNamespacedHelpers } from "vuex";
import { programService } from "@/module_dashboard/api/program";
import defaultThumbnail from "@/assets/images/defaultThumbnail.png";
import api from "@/module_b2b_users/api/api";
const { mapGetters: mapThemeGetters } = createNamespacedHelpers("themes");
import indefinite from 'indefinite'

function debounce(func, delay) {
  let timeoutId;

  return function(...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default {
  components: { ImageBanner },
  filters: {
    videoDuration: function(time) {
      // Hours, minutes and seconds
      const hrs = ~~(time / 3600);
      const mins = ~~((time % 3600) / 60);
      const secs = ~~time % 60;

      // Output like "01:01" or "04:03:59" or "123:03:59"
      let ret = "";
      if (hrs > 0) {
        ret += "" + (hrs > 9 ? hrs : "0" + hrs) + ":";
      }
      ret += "" + (mins > 9 ? mins : "0" + mins) + ":";
      ret += "" + (secs > 9 ? secs : "0" + secs);
      return ret;
    },
  },
  data() {
    return {
      assignedId: null,
      type: null,
      videos: [],
      programInfo: null,
      totalRecords: 1,
      totalPages: 1,
      currentPage: 1,
      pageSize: 5,
      isLoading: false,
      zeroContentAdded: false,

      // filters
      filter: null,
      defaultThumbnail: defaultThumbnail,
    };
  },
  computed: {
    ...mapThemeGetters(["theme", "pages"]),
    name() {
      return this.theme[this.pages.PROGRAMS].name;
    },
    requestParams() {
      return {
        page: this.currentPage,
        pageSize: this.pageSize,
        search: this.filter,
        attachInfo: !this.programInfo,
      };
    },
    corporateConfig() {
      return this.$store.state.userInfo?.corporate?.config?.challenge;
    },
    startButtonLabel() {
      const text =
        (this.programInfo?.completedWorkouts !== 0 ? "CONTINUE " : "START ") +
        this.name;
      return text.toUpperCase();
    },
    getLabel() {
      let {
        lastWorkoutTried,
        daysToComplete,
        programState,
        programStartDate,
        programEndDate,
      } = this.programInfo || {};
      const name = this.name.toLowerCase();
      lastWorkoutTried = new Date(lastWorkoutTried);
      programStartDate = new Date(programStartDate);
      programEndDate = new Date(programEndDate);
      switch (programState) {
        case "completed":
          return `this ${name} was completed on ${lastWorkoutTried.getDate()} ${lastWorkoutTried.toLocaleString(
            "default",
            { month: "short" }
          )} ${lastWorkoutTried.getFullYear()}`;
        case "upcoming":
          return;
        case "expired":
          return `This ${name} expired on ${programEndDate.getDate()} ${programEndDate.toLocaleString(
            "default",
            { month: "short" }
          )} ${programEndDate.getFullYear()}`;
        default:
          return `This is ${indefinite(daysToComplete)} Day ${name}`;
      }
    },
  },
  methods: {
    loadMyProgramVideos() {
      this.isLoading = true;
      programService
        .myProgramV2(this.assignedId, this.type)
        .then((data) => {
          this.videos = data.data.videos;
          this.programInfo = data.data;
        })
        .finally((_) => {
          this.isLoading = false;
        });
    },
    reset() {
      this.currentPage = 1;
      this.videos = [];
    },

    RedirectingToProgram(Program){
      if(Program.programId && Program.programType){
        this.$router.push(`/user/program/videos/v2?id=${Program.programId}&type=${Program.programType}`)
        return;
      }
      this.$bvToast.toast('This program is not currently assigned to you.', {
            variant: "danger",
            solid: true,
          });
    },

    getWorkoutIntensity(item) {
      if (!isNaN(+item.intensity) && item?.intensity <= 4.5) {
        return "Beginner";
      } else if (
        !isNaN(+item.intensity) &&
        item?.intensity <= 7.5 &&
        item?.intensity >= 5
      ) {
        return "Intermediate";
      } else if (!isNaN(+item.intensity) && item?.intensity >= 8) {
        return "Advanced";
      } else {
        return "";
      }
    },
    getSimilarCategoriesVideos(categoryId) {
      this.$router.push({ name: "Discover", query: { categoryId } });
    },
    async deleteHistory() {
      await api.deleteProgramHistory(this.assignedId);
      this.$router.push({ name: "b2b-programs" });
    },
    async createProgramHistory() {
      if (this.type == "individual") {
        return { data: { id: this.assignedId } };
      }
      return await api.createProgramHistory({
        assignedId: this.assignedId,
        type: this.type,
      });
    },
    async goToVideo(video) {
      try {
        if (
          !this.programInfo.isRequiredProgramCompleted ||
          this.programInfo.programState === "upcoming" ||
          this.programInfo.programState == "expired"
        ) {
          let message = "";

          if (this.programInfo.programState === "upcoming") {
            message = "Program has not started yet";
          } else if (this.programInfo.programState === "expired") {
            message = "Program has expired";
          } else if (!this.programInfo.isRequiredProgramCompleted) {
            message = `Please complete ${this.programInfo.requiredProgram.programName} before starting this program`;
          }

          this.$bvToast.toast(message, {
            variant: "danger",
            solid: true,
          });
          return;
        }

        const program = await this.createProgramHistory();
        const { id, tenantName, tenantId } = video;
        const currentPath = encodeURIComponent(this.$route.fullPath);
        this.$router.push(
          `/workout/${tenantName.replaceAll(
            /\s/g,
            ""
          )}?id=${id}&tryNow=true&returnToOnCancel=${currentPath}&programId=${
            program.data.id
          }`
        );
      } catch (error) {
        console.log(error);
      }
    },
    continueProgram() {
      if (this.type != "individual") {
        return this.goToVideo(this.videos[0]);
      }
      const index = this.videos.findIndex(
        (video) => video.is_workout_completed == false
      );
      if (index != -1) {
        return this.goToVideo(this.videos[index]);
      }
    },
    askDeleteConfirmation() {
      this.$swal
        .fire({
          title: "Do you want to continue?",
          text:
            "This program will be deleted, but you can still view your workouts in progress page",
          showDenyButton: true,
          confirmButtonText: "Yes",
          denyButtonText: `No`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteHistory();
          }
        });
    },
  },
  async mounted() {
    const query = this.$route.query;
    this.assignedId = query.id;
    this.type =
      query.type !== undefined &&
      ["corporate", "team", "individual"].includes(query.type)
        ? query.type
        : "individual";
    if (this.assignedId && this.type) this.loadMyProgramVideos();
  },
};
</script>
<style lang="scss" scoped>
.cursor-pointer{
  cursor: pointer;
  background-color: rgba(135, 207, 235, 0.7);
}

.gray-background {
  background: rgba(20, 21, 19, 0.45);
  backdrop-filter: blur(12px);
  border-radius: 12px;
}
.countdown-container {
  background: rgba(20, 21, 19, 0.45);
  backdrop-filter: blur(12px);
  border-radius: 12px;
  width: max-content;
  max-width: 80%;
  height: max-content;
}

.workout-wrapper {
  background: #ffffff !important;
}

.workout-button {
  color: #ffffff !important;
  background: #73bc44 !important;
  border-radius: 25px;
  border: 0 !important;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  padding: 8px 24px;
}

.ef-btn-banner-section {
  height: max-content;
  width: 100%;
  color: white;
  position: relative;
}

.ef-btn-banner-section .banner-img {
  width: 100%;
  height: auto;
  max-height: 95vh;
  object-fit: cover;
}

.back-button {
  padding: 0.7rem 1rem;
  left: calc(5% - 15px);
  top: 3%;
  background-color: rgba(20, 21, 19, 0.45);
  backdrop-filter: blur(12px);
  border-radius: 12px;
  width: fit-content !important;
  height: max-content;
}

.banner-content {
  bottom: 5%;
  left: 5%;
  width: 96%;
  right: 5%;
}

.workout-progress-wrapper {
  background: #f4f6f9 !important;
}

.challenge-progress-mobile {
  display: flex;
  flex-direction: column;
  background: #f4f6f9;
  box-sizing: border-box;
  border-radius: 12px;
  height: max-content;
  align-items: flex-start;
  padding: 16px 24px 16px 16px;
}

.challenge-container {
  padding: 0px 135px;
  left: 0px;
  top: 409px;
  background: #f4f6f9;
  overflow: scroll;
}

@media screen and (max-width: 768px) {
  .ef-btn-banner-section {
    height: auto;
  }
}

.challenge-wrapper {
  padding: 24px;
  top: 916px;
  background: #ffffff;
  box-shadow: 0px 16px 49px rgba(20, 21, 19, 0.15);
  border-radius: 12px;
  margin-top: 12px;
}

.challenge-wrapper-grey {
  padding: 24px;
  top: 916px;
  background: none;
  border-radius: 12px;
  margin-top: 12px;
}

.challenge-wrapper img,
.challenge-wrapper-grey img {
  border-radius: 12px;
}

.video-thumbnail {
  cursor: pointer;
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  object-fit: cover;
}

.video-duration {
  position: absolute;
  width: fit-content;
  right: 9px;
  bottom: 9px;
  text-align: center;
  color: #ffffff;
  background-color: #000000c9;
  border-radius: 2px;
  font-size: 12px;
  line-height: 18px;
  font-weight: bold;
  padding: 0 5px;
}

@media (max-width: 768px) {
  .challenge-container {
    padding: 0px 20px;
  }
}

.loader-wrapper {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 24px;
  z-index: 9999;
}
</style>
